import Button from "components/atoms/Button";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import { useFormik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Fasyankes from "services/Fasyankes";
import Ketenagaan from "services/Ketenagaan";
import Wilayah from "services/Wilayah";
import { errorToastNotif } from "utils/common";
import { PageMode, Source, UserLevel, YesAndNoOptions } from "utils/constant";
import React from "react";
import InputCheckbox from "components/atoms/InputCheckbox";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const ketenagaanService = new Ketenagaan();

const FormComponent = ({ selectedItem, pageMode, handlePageModeChange }) => {
  const { currentUser } = useSelector((state) => state.authReducer);
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });

  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
        excludePkm: false,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.fasyankes
          .filter((item) => item.fasyankes_type_id !== "jnsfas-02")
          .map((item) => {
            return {
              label: item.name,
              value: `${item.id}|${item.name}`,
            };
          }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
  }, [selectedProvince, selectedDistrict]);

  const formik = useFormik({
    initialValues: {
      ///Location Information
      province_id: currentUser?.province_id,
      district_id: currentUser?.district_id,
      kd_faskes: "",
      namapetugas: "",

      ///Training Information
      plthsismal: "", //Ya/Tidak
      thnplthsismal: null, //(year)
      plthmanajmalaria: "", //Ya/Tidak
      thnplthmanajmalaria: null, //(year)
      reorientasi: "", //Ya/Tidak
      thnreorientasi: null, //(year)
      plthsurvmal: "", //Ya/Tidak
      thnplthsurvmal: null, //(year)

      ///Medical Staff: Doctor
      dokterumum: "", //Ya/Tidak
      dokterumum_sosmal: "", //Ya/Tidak
      thn_dokterumum_sosmal: null, //(year)

      /// Internal Medicine Specialist
      dok_spd: "", //Ya/Tidak
      dok_spd_sosmal: "", //Ya/Tidak
      thn_dok_spd_sosmal: "", //(year)

      /// Pediatric Specialist
      dok_anak: "", //Ya/Tidak
      dok_anak_sosmal: "", //Ya/Tidak
      thn_dok_anak_sosmal: "", //(year)

      /// Obstetrician/Gynecologist Specialist
      dok_kand: "", //Ya/Tidak
      dokter_kand_sosmal: "", //Ya/Tidak
      thn_dokter_kand_sosmal: "", //(year)

      ///Medical Staff: Nurse
      perawat: "", //Ya/Tidak
      prwat_sosmal: "", //Ya/Tidak
      thn_jmlprwat_sosmal: null, //(year)
      prwt_skrining_sosmal_balita: "", //Ya/Tidak
      thn_jmlprwt_skrining_sosmal_balita: null, //(year)

      ///Medical Staff: Midwife
      bidan: "", //Ya/Tidak
      bidan_sosmal: "", //Ya/Tidak
      thn_jmlbidan_sosmal: null, //(year)
      bidan_sosmal_anc: "", //Ya/Tidak
      thn_jmlbidan_sosmal_anc: null, //(year)
      bidan_skrining_sosmal_balita: "", //Ya/Tidak
      thn_bidan_skrining_sosmal_balita: null, //(year)

      ///Health Promkes Staff
      ptgspromkes: "", //Ya/Tidak
      ptgspromkes_sosmal: "", //Ya/Tidak
      thn_ptgspromkes_sosmal: null, //(year)

      ///Entomology Staff
      entomologmal: "", //Ya/Tidak
      thn_plth_entomologmal: null, //(year)
    },
    validate: (values) => {
      const errors = {};

      ///Location Information
      if (!values.kd_faskes) {
        errors.kd_faskes = "Nama Puskesmas wajib diisi";
      }

      if (!values.namapetugas) {
        errors.namapetugas = "Nama pengelola malaria wajib diisi";
      }

      ///Training Information
      if (values.plthsismal === "Ya" && !values.thnplthsismal) {
        errors.thnplthsismal = "Tahun pelatihan terakhir wajib diisi";
      }

      if (values.plthmanajmalaria === "Ya" && !values.thnplthmanajmalaria) {
        errors.thnplthmanajmalaria = "Tahun reorientasi terakhir wajib diisi";
      }

      if (values.reorientasi === "Ya" && !values.thnreorientasi) {
        errors.thnreorientasi = "Tahun pelatihan SISMAL terakhir wajib diisi";
      }
      if (values.plthsurvmal === "Ya" && !values.thnplthsurvmal) {
        errors.thnplthsurvmal = "Tahun pelatihan terakhir wajib diisi";
      }

      ///Medical Staff: Doctor
      if (values.dokterumum === "Ya" && !values.dokterumum_sosmal) {
        errors.dokterumum_sosmal =
          "Ketersediaan dokter umum yang Tersosialisasi Tatalaksana Malaria wajib diisi";
      }

      if (values.dokterumum_sosmal === "Ya" && !values.thn_dokterumum_sosmal) {
        errors.thn_dokterumum_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Internal Medicine Specialist
      if (values.dok_spd === "Ya" && !values.dok_spd_sosmal) {
        errors.dok_spd_sosmal =
          "Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria wajib diisi";
      }

      if (values.dok_spd_sosmal === "Ya" && !values.thn_dok_spd_sosmal) {
        errors.thn_dok_spd_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Pediatric Specialist
      if (values.dok_anak === "Ya" && !values.dok_anak_sosmal) {
        errors.dok_anak_sosmal =
          "Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50) wajib diisi";
      }

      if (values.dok_anak_sosmal === "Ya" && !values.thn_dok_anak_sosmal) {
        errors.thn_dok_anak_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Obstetrician/Gynecologist  Specialist
      if (values.dok_kand === "Ya" && !values.dokter_kand_sosmal) {
        errors.dokter_kand_sosmal =
          "Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria wajib diisi";
      }

      if (
        values.dokter_kand_sosmal === "Ya" &&
        !values.thn_dokter_kand_sosmal
      ) {
        errors.thn_dokter_kand_sosmal =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Medical Staff: Nurse
      if (values.perawat === "Ya" && !values.prwat_sosmal) {
        errors.prwat_sosmal =
          "Ketersediaan perawat yang tersosialisasi tatalaksana malaria wajib diisi";
      }

      if (values.prwat_sosmal === "Ya" && !values.thn_jmlprwat_sosmal) {
        errors.thn_jmlprwat_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.perawat === "Ya" && !values.prwt_skrining_sosmal_balita) {
        errors.prwt_skrining_sosmal_balita =
          "Ketersediaan Perawat yang tersosialisasi Skrining malaria pada balita di Kab/Kota dengan Endemis Tinggi wajib diisi";
      }

      if (
        values.prwt_skrining_sosmal_balita === "Ya" &&
        !values.thn_jmlprwt_skrining_sosmal_balita
      ) {
        errors.thn_jmlprwt_skrining_sosmal_balita =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Medical Staff: Midwife
      if (values.bidan === "Ya" && !values.bidan_sosmal) {
        errors.bidan_sosmal =
          "Ketersediaan bidan yang tersosialisasi tatalaksana malaria wajib diisi";
      }

      if (values.bidan_sosmal === "Ya" && !values.thn_jmlbidan_sosmal) {
        errors.thn_jmlbidan_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.bidan === "Ya" && !values.bidan_sosmal_anc) {
        errors.bidan_sosmal_anc =
          "Ketersediaan bidan yang tersosialisasi skrining malaria pada ibu hamil di Kab/Kota dengan endemis tinggi wajib diisi";
      }

      if (values.bidan_sosmal_anc === "Ya" && !values.thn_jmlbidan_sosmal_anc) {
        errors.thn_jmlbidan_sosmal_anc =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.bidan === "Ya" && !values.bidan_skrining_sosmal_balita) {
        errors.bidan_skrining_sosmal_balita =
          "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi wajib diisi";
      }

      if (
        values.bidan_skrining_sosmal_balita === "Ya" &&
        !values.thn_bidan_skrining_sosmal_balita
      ) {
        errors.thn_bidan_skrining_sosmal_balita =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Health Promkes Staff
      if (values.ptgspromkes === "Ya" && !values.ptgspromkes_sosmal) {
        errors.ptgspromkes_sosmal =
          "Ketersediaan tenaga promkes yang tersosialisasi tentang komunikasi malaria wajib diisi";
      }

      if (
        values.ptgspromkes_sosmal === "Ya" &&
        !values.thn_ptgspromkes_sosmal
      ) {
        errors.thn_ptgspromkes_sosmal =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Entomology Staff
      if (values.entomologmal === "Ya" && !values.thn_plth_entomologmal) {
        errors.thn_plth_entomologmal = "Tahun sosialisasi terakhir wajib diisi";
      }
      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        ///Location Information
        kd_prop: currentUser?.province_id
          ? currentUser.province_id.split("|")[0]
          : "",
        kd_kab: currentUser?.district_id
          ? currentUser.district_id.split("|")[0]
          : "",
        tgl_simpan: moment().format("YYYY-MM-DD"),
        tipefaskes: "1",
        id_tenaga: values.kd_faskes ? values.kd_faskes.split("|")[0] : "",
        kd_faskes: values.kd_faskes ? values.kd_faskes.split("|")[0] : "",
        namapetugas: values.namapetugas,

        ///Training Information
        plthsismal: values.plthsismal,
        thnplthsismal: values.thnplthsismal,
        plthmanajmalaria: values.plthmanajmalaria,
        thnplthmanajmalaria: values.thnplthmanajmalaria,
        reorientasi: values.reorientasi,
        thnreorientasi: values.thnreorientasi,
        plthsurvmal: values.plthsurvmal,
        thnplthsurvmal: values.thnplthsurvmal,

        ///Medical Staff: Doctor
        dokterumum: values.dokterumum,
        dokterumum_sosmal: values.dokterumum_sosmal,
        thn_dokterumum_sosmal: values.thn_dokterumum_sosmal,

        /// Internal Medicine Specialist
        dok_spd: values.dok_spd,
        dok_spd_sosmal: values.dok_spd_sosmal,
        thn_dok_spd_sosmal: values.thn_dok_spd_sosmal,

        /// Pediatric Specialist
        dok_anak: values.dok_anak,
        dok_anak_sosmal: values.dok_anak_sosmal,
        thn_dok_anak_sosmal: values.thn_dok_anak_sosmal,

        /// Obstetrician/Gynecologist Specialist
        dok_kand: values.dok_kand,
        dokter_kand_sosmal: values.dokter_kand_sosmal,
        thn_dokter_kand_sosmal: values.thn_dokter_kand_sosmal,

        ///Medical Staff: Nurse
        perawat: values.perawat,
        prwat_sosmal: values.prwat_sosmal,
        thn_jmlprwat_sosmal: values.thn_jmlprwat_sosmal,
        prwt_skrining_sosmal_balita: values.prwt_skrining_sosmal_balita,
        thn_jmlprwt_skrining_sosmal_balita:
          values.thn_jmlprwt_skrining_sosmal_balita,

        ///Medical Staff: Midwife
        bidan: values.bidan,
        bidan_sosmal: values.bidan_sosmal,
        thn_jmlbidan_sosmal: values.thn_jmlbidan_sosmal,
        bidan_sosmal_anc: values.bidan_sosmal_anc,
        thn_jmlbidan_sosmal_anc: values.thn_jmlbidan_sosmal_anc,
        bidan_skrining_sosmal_balita: values.bidan_skrining_sosmal_balita,
        thn_bidan_skrining_sosmal_balita:
          values.thn_bidan_skrining_sosmal_balita,

        ///Health Promkes Staff
        ptgspromkes: values.ptgspromkes,
        ptgspromkes_sosmal: values.ptgspromkes_sosmal,
        thn_ptgspromkes_sosmal: values.thn_ptgspromkes_sosmal,

        ///Entomology Staff
        entomologmal: values.entomologmal,
        thn_plth_entomologmal: values.thn_plth_entomologmal,
      };

      switch (pageMode) {
        case PageMode.add:
          await ketenagaanService
            .add(payload)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Ketenagaan berhasil ditambahkan", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await ketenagaanService
            .update(payload, selectedItem?.kd_id)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Ketenagaan berhasil diupdate", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  const getUrbanvillagesByCurrentUser = async () => {
    try {
      const response = await WilayahService.getAll(Source.URBANVILLAGE, {
        searchBy: "subdistrict_id",
        searchValue: currentUser?.subdistrict_id?.split("|")[0],
        page: 1,
        limit: 9999,
      });
      setUrbanvillages(response.urbanvillage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUrbanvillagesByCurrentUser();
  }, []);

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      formik.setValues({
        kd_faskes: selectedItem.kd_faskes,
        namapetugas: selectedItem.namapetugas,

        ///Training Information
        plthsismal: selectedItem.plthsismal,
        thnplthsismal: selectedItem.thnplthsismal,
        plthmanajmalaria: selectedItem.plthmanajmalaria,
        thnplthmanajmalaria: selectedItem.thnplthmanajmalaria,
        reorientasi: selectedItem.reorientasi,
        thnreorientasi: selectedItem.thnreorientasi,
        plthsurvmal: selectedItem.plthsurvmal,
        thnplthsurvmal: selectedItem.thnplthsurvmal,

        ///Medical Staff: Doctor
        dokterumum: selectedItem.dokterumum,
        dokterumum_sosmal: selectedItem.dokterumum_sosmal,
        thn_dokterumum_sosmal: selectedItem.thn_dokterumum_sosmal,

        /// Internal Medicine Specialist
        dok_spd: selectedItem.dok_spd,
        dok_spd_sosmal: selectedItem.dok_spd_sosmal,
        thn_dok_spd_sosmal: selectedItem.thn_dok_spd_sosmal,

        /// Pediatric Specialist
        dok_anak: selectedItem.dok_anak,
        dok_anak_sosmal: selectedItem.dok_anak_sosmal,
        thn_dok_anak_sosmal: selectedItem.thn_dok_anak_sosmal,

        /// Obstetrician/Gynecologist Specialist
        dok_kand: selectedItem.dok_kand,
        dokter_kand_sosmal: selectedItem.dokter_kand_sosmal,
        thn_dokter_kand_sosmal: selectedItem.thn_dokter_kand_sosmal,

        ///Medical Staff: Nurse
        perawat: selectedItem.perawat,
        prwat_sosmal: selectedItem.prwat_sosmal,
        thn_jmlprwat_sosmal: selectedItem.thn_jmlprwat_sosmal,
        prwt_skrining_sosmal_balita: selectedItem.prwt_skrining_sosmal_balita,
        thn_jmlprwt_skrining_sosmal_balita:
          selectedItem.thn_jmlprwt_skrining_sosmal_balita,

        ///Medical Staff: Midwife
        bidan: selectedItem.bidan,
        bidan_sosmal: selectedItem.bidan_sosmal,
        thn_jmlbidan_sosmal: selectedItem.thn_jmlbidan_sosmal,
        bidan_sosmal_anc: selectedItem.bidan_sosmal_anc,
        thn_jmlbidan_sosmal_anc: selectedItem.thn_jmlbidan_sosmal_anc,
        bidan_skrining_sosmal_balita: selectedItem.bidan_skrining_sosmal_balita,
        thn_bidan_skrining_sosmal_balita:
          selectedItem.thn_bidan_skrining_sosmal_balita,

        ///Health Promkes Staff
        ptgspromkes: selectedItem.ptgspromkes,
        ptgspromkes_sosmal: selectedItem.ptgspromkes_sosmal,
        thn_ptgspromkes_sosmal: selectedItem.thn_ptgspromkes_sosmal,

        ///Entomology Staff
        entomologmal: selectedItem.entomologmal,
        thn_plth_entomologmal: selectedItem.thn_plth_entomologmal,
      });
    }
  }, [selectedItem]);

  return (
    <>
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Ketenagaan - Puskesmas"
          : "Edit Ketenagaan - Puskesmas"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>
        <div className="row">
          <div className="col-sm-6 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Provinsi"}
              data={levelDataOptions.provinces}
              onChange={(e) => {
                setSelectedProvince(e.value);
                setSelectedDistrict("");
              }}
              value={
                levelDataOptions.provinces?.find(
                  (item) => item.value === selectedProvince
                ) || ""
              }
              isDisabled={true}
            />
          </div>

          <div className="col-sm-6 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Kab/Kota"}
              data={levelDataOptions.districts}
              onChange={(e) => {
                setSelectedDistrict(e.value);
              }}
              value={
                levelDataOptions.districts?.find(
                  (item) => item.value === selectedDistrict
                ) || ""
              }
              isDisabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 mb-3">
            <InputSelect
              isClearable={false}
              isMultipleSelect={false}
              label={"Fasyankes"}
              placeholder={"Pilih Fasyankes"}
              data={levelDataOptions.fasyankes}
              onChange={(e) => {
                formik.setFieldValue("kd_faskes", e.value);
              }}
              value={
                levelDataOptions.fasyankes?.find(
                  (option) =>
                    option.value.split("|")[0] === formik.values.kd_faskes
                ) || null
              }
              isRequired={true}
            />
          </div>
          <div className="col-sm-6 mb-3">
            <InputField
              label={"Nama pengelola malaria"}
              name={"namapetugas"}
              placeholder={"Masukkan Nama pengelola malaria"}
              type={"text"}
              {...formik.getFieldProps("namapetugas")}
              error={formik.errors.namapetugas && formik.touched.namapetugas}
              errorMessage={formik.errors.namapetugas}
              value={formik.values.namapetugas}
              isRequired={true}
            />
          </div>
        </div>
        <hr />

        <label className="font-weight-bold">
          {"Pelatihan/Sosialisasi Yang Diikuti oleh Pengelola Malaria "}
        </label>
        <div className="row">
          <div className="col-sm-6 mb-3">
            <div className="d-flex flex-column gap-3">
              <div>
                <InputCheckbox
                  options={[
                    { label: "Pelatihan manajemen dasar program malaria bagi tenaga pengelola program malaria", value: "Ya" },
                  ]}
                  name="plthmanajmalaria"
                  onChange={(e) => {
                    const selectedValue = e.target.checked ? "Ya" : "Tidak";

                    if (selectedValue !== "Ya") {
                      formik.setFieldValue("thnplthmanajmalaria", "");
                    }

                    formik.handleChange("plthmanajmalaria")(selectedValue);
                  }}
                  onBlur={formik.handleBlur}
                  selectedOption={formik.values.plthmanajmalaria}
                  error={
                    formik.errors.plthmanajmalaria &&
                    formik.touched.plthmanajmalaria
                  }
                  errorMessage={formik.errors.plthmanajmalaria}
                />
              </div>

              <div>
                <InputDate
                  label={"Tahun pelatihan terakhir"}
                  name={"thnplthmanajmalaria"}
                  placeholder={"Pilih Tahun pelatihan terakhir"}
                  value={
                    formik.values.thnplthmanajmalaria
                      ? moment(formik.values.thnplthmanajmalaria, "YYYY")
                      : null
                  }
                  onChange={(e) => {
                    const selectedYear = moment(e).format("YYYY");
                    formik.setFieldValue("thnplthmanajmalaria", selectedYear);
                  }}
                  dateFormat={"YYYY"}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.thnplthmanajmalaria &&
                    formik.touched.thnplthmanajmalaria
                  }
                  errorMessage={formik.errors.thnplthmanajmalaria}
                  isDisabled={formik.values.plthmanajmalaria !== "Ya"}
                  isValidDate={(current) => current.year() <= moment().year()}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6 mb-3">
            <div className="d-flex flex-column gap-3">
              <div>
                <InputCheckbox
                  options={[
                    {
                      label: "Pelatihan/sosialisasi reorientasi program",
                      value: "Ya",
                    },
                  ]}
                  name="reorientasi"
                  onChange={(e) => {
                    const selectedValue = e.target.checked ? "Ya" : "Tidak";

                    if (selectedValue !== "Ya") {
                      formik.setFieldValue("thnreorientasi", "");
                    }

                    formik.handleChange("reorientasi")(selectedValue);
                  }}
                  onBlur={formik.handleBlur}
                  selectedOption={formik.values.reorientasi}
                  error={
                    formik.errors.reorientasi && formik.touched.reorientasi
                  }
                  errorMessage={formik.errors.reorientasi}
                />
              </div>

              <div>
                <InputDate
                  label={"Tahun reorientasi terakhir"}
                  name={"thnreorientasi"}
                  placeholder={"Pilih Tahun reorientasi terakhir"}
                  value={
                    formik.values.thnreorientasi
                      ? moment(formik.values.thnreorientasi, "YYYY")
                      : null
                  }
                  onChange={(e) => {
                    const selectedYear = moment(e).format("YYYY");
                    formik.setFieldValue("thnreorientasi", selectedYear);
                  }}
                  dateFormat={"YYYY"}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.thnreorientasi &&
                    formik.touched.thnreorientasi
                  }
                  errorMessage={formik.errors.thnreorientasi}
                  isDisabled={formik.values.reorientasi !== "Ya"}
                  isValidDate={(current) => current.year() <= moment().year()}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 mb-3">
            <div className="d-flex flex-column gap-3">
              <div>
                <InputCheckbox
                  options={[{ label: "Pelatihan SISMAL", value: "Ya" }]}
                  name="plthsismal"
                  onChange={(e) => {
                    const selectedValue = e.target.checked ? "Ya" : "Tidak";

                    if (selectedValue !== "Ya") {
                      formik.setFieldValue("thnplthsismal", "");
                    }

                    formik.handleChange("plthsismal")(selectedValue);
                  }}
                  onBlur={formik.handleBlur}
                  selectedOption={formik.values.plthsismal}
                  error={formik.errors.plthsismal && formik.touched.plthsismal}
                  errorMessage={formik.errors.plthsismal}
                />
              </div>

              <div>
                <InputDate
                  label={"Tahun pelatihan terakhir"}
                  name={"thnplthsismal"}
                  placeholder={"Pilih Tahun pelatihan terakhir"}
                  value={
                    formik.values.thnplthsismal
                      ? moment(formik.values.thnplthsismal, "YYYY")
                      : null
                  }
                  onChange={(e) => {
                    const selectedYear = moment(e).format("YYYY");
                    formik.setFieldValue("thnplthsismal", selectedYear);
                  }}
                  dateFormat={"YYYY"}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.thnplthsismal && formik.touched.thnplthsismal
                  }
                  errorMessage={formik.errors.thnplthsismal}
                  isDisabled={formik.values.plthsismal !== "Ya"}
                  isValidDate={(current) => current.year() <= moment().year()}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6 mb-3">
            <div className="d-flex flex-column gap-3">
              <div>
                <InputCheckbox
                  options={[
                    {
                      label:
                        "Pelatihan/sosialisasi surveilans malaria (PE, surv migrasi, surv malaria daerah tinggi)",
                      value: "Ya",
                    },
                  ]}
                  name="plthsurvmal"
                  onChange={(e) => {
                    const selectedValue = e.target.checked ? "Ya" : "Tidak";

                    if (selectedValue !== "Ya") {
                      formik.setFieldValue("thnplthsurvmal", "");
                    }

                    formik.handleChange("plthsurvmal")(selectedValue);
                  }}
                  onBlur={formik.handleBlur}
                  selectedOption={formik.values.plthsurvmal}
                  error={
                    formik.errors.plthsurvmal && formik.touched.plthsurvmal
                  }
                  errorMessage={formik.errors.plthsurvmal}
                />
              </div>

              <div>
                <InputDate
                  label={"Tahun pelatihan terakhir"}
                  name={"thnplthsurvmal"}
                  placeholder={"Pilih Tahun pelatihan terakhir"}
                  value={
                    formik.values.thnplthsurvmal
                      ? moment(formik.values.thnplthsurvmal, "YYYY")
                      : null
                  }
                  onChange={(e) => {
                    const selectedYear = moment(e).format("YYYY");
                    formik.setFieldValue("thnplthsurvmal", selectedYear);
                  }}
                  dateFormat={"YYYY"}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.thnplthsurvmal &&
                    formik.touched.thnplthsurvmal
                  }
                  errorMessage={formik.errors.thnplthsurvmal}
                  isDisabled={formik.values.plthsurvmal !== "Ya"}
                  isValidDate={(current) => current.year() <= moment().year()}
                />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter umum?"}
              name={"dokterumum"}
              placeholder={"Pilih Ketersediaan dokter umum?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokterumum", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dokterumum_sosmal", "");
                  formik.setFieldValue("thn_dokterumum_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokterumum
              )}
              error={formik.errors.dokterumum && formik.touched.dokterumum}
              errorMessage={formik.errors.dokterumum}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter umum yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dokterumum_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter umum yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokterumum_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dokterumum_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokterumum_sosmal
              )}
              error={
                formik.errors.dokterumum_sosmal &&
                formik.touched.dokterumum_sosmal
              }
              errorMessage={formik.errors.dokterumum_sosmal}
              disabled={formik.values.dokterumum !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dokterumum_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dokterumum_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dokterumum_sosmal
                  ? moment(formik.values.thn_dokterumum_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dokterumum_sosmal &&
                formik.touched.thn_dokterumum_sosmal
              }
              errorMessage={formik.errors.thn_dokterumum_sosmal}
              isDisabled={formik.values.dokterumum_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis penyakit dalam?"}
              name={"dok_spd"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis penyakit dalam?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_spd", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_spd_sosmal", "");
                  formik.setFieldValue("thn_dok_spd_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_spd
              )}
              error={formik.errors.dok_spd && formik.touched.dok_spd}
              errorMessage={formik.errors.dok_spd}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dok_spd_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_spd_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_spd_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_spd_sosmal
              )}
              error={
                formik.errors.dok_spd_sosmal && formik.touched.dok_spd_sosmal
              }
              errorMessage={formik.errors.dok_spd_sosmal}
              disabled={formik.values.dok_spd !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_spd_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dok_spd_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_spd_sosmal
                  ? moment(formik.values.thn_dok_spd_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_spd_sosmal &&
                formik.touched.thn_dok_spd_sosmal
              }
              errorMessage={formik.errors.thn_dok_spd_sosmal}
              isDisabled={formik.values.dok_spd_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis anak?"}
              name={"dok_anak"}
              placeholder={"Pilih Ketersediaan dokter spesialis anak?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_anak", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_anak_sosmal", "");
                  formik.setFieldValue("thn_dok_anak_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_anak
              )}
              error={formik.errors.dok_anak && formik.touched.dok_anak}
              errorMessage={formik.errors.dok_anak}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50)"
              }
              name={"dok_anak_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50)"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_anak_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_anak_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_anak_sosmal
              )}
              error={
                formik.errors.dok_anak_sosmal && formik.touched.dok_anak_sosmal
              }
              errorMessage={formik.errors.dok_anak_sosmal}
              disabled={formik.values.dok_anak !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_anak_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dok_anak_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_anak_sosmal
                  ? moment(formik.values.thn_dok_anak_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_anak_sosmal &&
                formik.touched.thn_dok_anak_sosmal
              }
              errorMessage={formik.errors.thn_dok_anak_sosmal}
              isDisabled={formik.values.dok_anak_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis kandungan?"}
              name={"dok_kand"}
              placeholder={"Pilih Ketersediaan dokter spesialis kandungan?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_kand", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dokter_kand_sosmal", "");
                  formik.setFieldValue("thn_dokter_kand_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_kand
              )}
              error={formik.errors.dok_kand && formik.touched.dok_kand}
              errorMessage={formik.errors.dok_kand}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dokter_kand_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokter_kand_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dokter_kand_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokter_kand_sosmal
              )}
              error={
                formik.errors.dokter_kand_sosmal &&
                formik.touched.dokter_kand_sosmal
              }
              errorMessage={formik.errors.dokter_kand_sosmal}
              disabled={formik.values.dok_kand !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dokter_kand_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dokter_kand_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dokter_kand_sosmal
                  ? moment(formik.values.thn_dokter_kand_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dokter_kand_sosmal &&
                formik.touched.thn_dokter_kand_sosmal
              }
              errorMessage={formik.errors.thn_dokter_kand_sosmal}
              isDisabled={formik.values.dokter_kand_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan perawat?"}
              name={"perawat"}
              placeholder={"Pilih Ketersediaan perawat?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("perawat", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("prwat_sosmal", "");
                  formik.setFieldValue("thn_jmlprwat_sosmal", "");
                  formik.setFieldValue("prwt_skrining_sosmal_balita", "");
                  formik.setFieldValue(
                    "thn_jmlprwt_skrining_sosmal_balita",
                    ""
                  );
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.perawat
              )}
              error={formik.errors.perawat && formik.touched.perawat}
              errorMessage={formik.errors.perawat}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan perawat yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"prwat_sosmal"}
              placeholder={
                "Pilih Ketersediaan perawat yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("prwat_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlprwat_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.prwat_sosmal
              )}
              error={formik.errors.prwat_sosmal && formik.touched.prwat_sosmal}
              errorMessage={formik.errors.prwat_sosmal}
              disabled={formik.values.perawat !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlprwat_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlprwat_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlprwat_sosmal
                  ? moment(formik.values.thn_jmlprwat_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlprwat_sosmal &&
                formik.touched.thn_jmlprwat_sosmal
              }
              errorMessage={formik.errors.thn_jmlprwat_sosmal}
              isDisabled={formik.values.prwat_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan perawat yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              name={"prwt_skrining_sosmal_balita"}
              placeholder={
                "Pilih Ketersediaan perawat yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue(
                  "prwt_skrining_sosmal_balita",
                  selectedValue
                );
                if (selectedValue !== "Ya") {
                  formik.setFieldValue(
                    "thn_jmlprwt_skrining_sosmal_balita",
                    ""
                  );
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.prwt_skrining_sosmal_balita
              )}
              error={
                formik.errors.prwt_skrining_sosmal_balita &&
                formik.touched.prwt_skrining_sosmal_balita
              }
              errorMessage={formik.errors.prwt_skrining_sosmal_balita}
              disabled={formik.values.perawat !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlprwt_skrining_sosmal_balita"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue(
                  "thn_jmlprwt_skrining_sosmal_balita",
                  selectedYear
                );
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlprwt_skrining_sosmal_balita
                  ? moment(
                      formik.values.thn_jmlprwt_skrining_sosmal_balita,
                      "YYYY"
                    )
                  : null
              }
              error={
                formik.errors.thn_jmlprwt_skrining_sosmal_balita &&
                formik.touched.thn_jmlprwt_skrining_sosmal_balita
              }
              errorMessage={formik.errors.thn_jmlprwt_skrining_sosmal_balita}
              isDisabled={formik.values.prwt_skrining_sosmal_balita !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan bidan?"}
              name={"bidan"}
              placeholder={"Pilih Ketersediaan bidan?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("bidan_sosmal", "");
                  formik.setFieldValue("thn_jmlbidan_sosmal", "");
                  formik.setFieldValue("bidan_sosmal_anc", "");
                  formik.setFieldValue("thn_jmlbidan_sosmal_anc", "");
                  formik.setFieldValue("bidan_skrining_sosmal_balita", "");
                  formik.setFieldValue("thn_bidan_skrining_sosmal_balita", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan
              )}
              error={formik.errors.bidan && formik.touched.bidan}
              errorMessage={formik.errors.bidan}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"bidan_sosmal"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlbidan_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan_sosmal
              )}
              error={formik.errors.bidan_sosmal && formik.touched.bidan_sosmal}
              errorMessage={formik.errors.bidan_sosmal}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlbidan_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlbidan_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlbidan_sosmal
                  ? moment(formik.values.thn_jmlbidan_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlbidan_sosmal &&
                formik.touched.thn_jmlbidan_sosmal
              }
              errorMessage={formik.errors.thn_jmlbidan_sosmal}
              isDisabled={formik.values.bidan_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada kegiatan ANC di kab/kota dengan endemis tinggi?"
              }
              name={"bidan_sosmal_anc"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada kegiatan ANC di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan_sosmal_anc", selectedValue);

                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlbidan_sosmal_anc", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan_sosmal_anc
              )}
              error={
                formik.errors.bidan_sosmal_anc &&
                formik.touched.bidan_sosmal_anc
              }
              errorMessage={formik.errors.bidan_sosmal_anc}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlbidan_sosmal_anc"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlbidan_sosmal_anc", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlbidan_sosmal_anc
                  ? moment(formik.values.thn_jmlbidan_sosmal_anc, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlbidan_sosmal_anc &&
                formik.touched.thn_jmlbidan_sosmal_anc
              }
              errorMessage={formik.errors.thn_jmlbidan_sosmal_anc}
              isDisabled={formik.values.bidan_sosmal_anc !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              name={"bidan_skrining_sosmal_balita"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue(
                  "bidan_skrining_sosmal_balita",
                  selectedValue
                );
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_bidan_skrining_sosmal_balita", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.bidan_skrining_sosmal_balita
              )}
              error={
                formik.errors.bidan_skrining_sosmal_balita &&
                formik.touched.bidan_skrining_sosmal_balita
              }
              errorMessage={formik.errors.bidan_skrining_sosmal_balita}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_bidan_skrining_sosmal_balita"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue(
                  "thn_bidan_skrining_sosmal_balita",
                  selectedYear
                );
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_bidan_skrining_sosmal_balita
                  ? moment(
                      formik.values.thn_bidan_skrining_sosmal_balita,
                      "YYYY"
                    )
                  : null
              }
              error={
                formik.errors.thn_bidan_skrining_sosmal_balita &&
                formik.touched.thn_bidan_skrining_sosmal_balita
              }
              errorMessage={formik.errors.thn_bidan_skrining_sosmal_balita}
              isDisabled={formik.values.bidan_skrining_sosmal_balita !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan tenaga promkes?"}
              name={"ptgspromkes"}
              placeholder={"Pilih Ketersediaan tenaga promkes?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("ptgspromkes", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("ptgspromkes_sosmal", "");
                  formik.setFieldValue("thn_ptgspromkes_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.ptgspromkes
              )}
              error={formik.errors.ptgspromkes && formik.touched.ptgspromkes}
              errorMessage={formik.errors.ptgspromkes}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan tenaga promkes yang sudah mendapat sosialisasi tentang komunikasi malaria?"
              }
              name={"ptgspromkes_sosmal"}
              placeholder={
                "Pilih Ketersediaan tenaga promkes yang sudah mendapat sosialisasi tentang komunikasi malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("ptgspromkes_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_ptgspromkes_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.ptgspromkes_sosmal
              )}
              error={
                formik.errors.ptgspromkes_sosmal &&
                formik.touched.ptgspromkes_sosmal
              }
              errorMessage={formik.errors.ptgspromkes_sosmal}
              disabled={formik.values.ptgspromkes !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_ptgspromkes_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_ptgspromkes_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_ptgspromkes_sosmal
                  ? moment(formik.values.thn_ptgspromkes_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_ptgspromkes_sosmal &&
                formik.touched.thn_ptgspromkes_sosmal
              }
              errorMessage={formik.errors.thn_ptgspromkes_sosmal}
              isDisabled={formik.values.ptgspromkes_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"Ketersediaan tenaga terlatih entomologi malaria?"}
              name={"entomologmal"}
              placeholder={
                "Pilih Ketersediaan tenaga terlatih entomologi malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("entomologmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_plth_entomologmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.entomologmal
              )}
              error={formik.errors.entomologmal && formik.touched.entomologmal}
              errorMessage={formik.errors.entomologmal}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_plth_entomologmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_plth_entomologmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_plth_entomologmal
                  ? moment(formik.values.thn_plth_entomologmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_plth_entomologmal &&
                formik.touched.thn_plth_entomologmal
              }
              errorMessage={formik.errors.thn_plth_entomologmal}
              isDisabled={formik.values.entomologmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        {/* Action button */}
        <div className="button_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => handlePageModeChange(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            type={"submit"}
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={
              formik.isSubmitting ||
              !formik.values.kd_faskes ||
              !formik.values.namapetugas
            }
          >
            {pageMode === PageMode.edit ? "Ubah Data" : "Simpan Data"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
